const organisationSettingsPath = '/organisation-settings';
const planSettingsPath = '/plan-settings';
const organisationIdParam = 'organisationId';

const buildScopedSettingsHref = (path: string, organisationId: string): string => {
  const searchParams = new URLSearchParams({ [organisationIdParam]: organisationId });
  return `${path}?${searchParams.toString()}`;
};

export const buildOrganisationSettingsHref = (organisationId: string): string =>
  buildScopedSettingsHref(organisationSettingsPath, organisationId);

export const buildPlanSettingsHref = (organisationId: string): string =>
  buildScopedSettingsHref(planSettingsPath, organisationId);

export const resolveSettingsOrganisationId = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  const organisationId = searchParams.get(organisationIdParam)?.trim() ?? '';
  return organisationId.length > 0 ? organisationId : null;
};
